import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import ModalFilterBatismo from "./filtro";
import SearchInput from "../../../../components/inputs/searchInput";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import { useServicesMembroBatismo } from "../context/getServices";


interface HeaderComponentsProps {

}

const HeaderComponentsBatismoMembros: FunctionComponent<HeaderComponentsProps> = () => {

  const { listAll, getSearchPerMinister } = useServicesMembroBatismo()

  return (<SecaoButao style={{ marginBottom: 5 }}>
    <section style={{ display: 'flex', gap: 5 }}>
      <ModalExportar
        callDownloadExcel={() => OpenExcelUniversal(listAll, ["nome", "idade", "email", "telefone", "genero", "estadocivil", "nomesede", "dataevento", "inscricao", "camisa", "batizado"])}
        callDownloadPdf={() => DonwloadPdf(listAll, ["Nome", "Idade", "Email", "Contato", "Genero", "Estado Civil", "Sede", "Data Batismo", "Inscrição", "Camisa", "Batizado"],
          ["nome", "idade", "email", "telefone", "genero", "estadocivil", "nomesede", "dataevento", "inscricao", "camisa", "batizado"], listAll?.length, [], `${listAll?.length}`)
        }
      />
      <ModalFilterBatismo
      />

    </section>
    <SearchInput
      placeholder="Procure por nome ou evento"
      onChange={getSearchPerMinister} />

  </SecaoButao>);
}

export default HeaderComponentsBatismoMembros;
